import { GatsbyImage } from "gatsby-plugin-image";
import styled from "styled-components";

import {
  AspectRatio,
  Box,
  BoxProps,
  DiscountBadge,
} from "@vinomofo/components";

import { StorefrontImage } from "../../types";
import { OfferSoldOut } from "./OfferSoldOut";
import { DiscountDisplay } from "../../types/vino-data-types";
import { discountDisplays } from "../../utils/constants";

export interface OfferHeroImageProps extends BoxProps {
  name: string;
  image: StorefrontImage;
  isAvailable: boolean;
  discountPercent: number;
  discountDollarValue: number;
  discountDisplay: DiscountDisplay;
  showDiscountBadge: boolean;
}

const StyledOfferSoldOut = styled(OfferSoldOut)`
  transform: translateX(-50%);
  left: 50%;
  top: 50px;
`;

const StyledDiscountBadge = styled(DiscountBadge)`
  right: 0;
  top: -13px;
  > span:first-of-type {
    font-size: 22px;
  }
  > p:first-of-type {
    font-size: 10px;
  }
`;

export const OfferHeroImageLarge = ({
  name,
  image,
  isAvailable,
  discountPercent,
  discountDollarValue,
  discountDisplay,
  showDiscountBadge,
  ...rest
}: OfferHeroImageProps): JSX.Element => {
  return (
    <Box position="relative" mb={[0, 40, 0]} mt={[0, 0, 0]} {...rest}>
      <AspectRatio ratio={3 / 2}>
        <GatsbyImage
          image={image}
          style={{
            width: "100%",
            height: "100%",
            textAlign: "center",
            borderRadius: 0,
            overflow: "hidden",
          }}
          imgStyle={{
            objectFit: "cover",
            objectPosition: "bottom center",
            top: "auto",
            bottom: "0",
            width: "100%",
            height: "100%",
          }}
          alt={name}
        />
      </AspectRatio>
      {!isAvailable && <StyledOfferSoldOut position="absolute" />}
      {isAvailable && showDiscountBadge && (
        <StyledDiscountBadge
          position="absolute"
          amount={
            discountDisplay === discountDisplays.dollar
              ? discountDollarValue
              : discountPercent
          }
          discountDisplay={discountDisplay}
          variant="lg"
        />
      )}
    </Box>
  );
};
